import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "אפלאטס — אפליקציה לניהול אימונים ומתאמנים לסטודיו שלך" },
  },
  {
    // Barbershops, beauty and nail salons. The same sections as home, with
    // salon copy and the salon theme.
    path: "/salons",
    name: "salons",
    component: () => import("../views/SalonsView.vue"),
    meta: {
      title: "אפלאטס — אפליקציה לניהול תורים למספרות, סלוני יופי וציפורניים",
      description:
        "אפליקציה ממותגת לקביעת תורים למספרות, סלוני יופי ומכוני ציפורניים. הלקוחות קובעים תור לבד, מקבלים תזכורת, ואתם מקבלים יומן מלא.",
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/PrivacyPolicyView.vue"),
    meta: { title: "מדיניות הפרטיות — אפלאטס" },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/TermsScreen.vue"),
    meta: { title: "תנאי שימוש — אפלאטס" },
  },
  {
    path: "/download",
    name: "download",
    component: () => import("../views/DownloadView.vue"),
    meta: { title: "הורדת האפליקציה — אפלאטס" },
  },
  {
    // A business's own download page, shared by the business with its
    // customers. Reached only by its URL.
    path: "/app/:businessKey",
    name: "business-app",
    component: () => import("../views/BusinessAppView.vue"),
    props: true,
    meta: { title: "הורדת האפליקציה" },
  },
  {
    // The old spelling was public, and businesses shared it as
    // /download-link?key=<businessKey>&name=…&custom=1. Keep those working.
    path: "/download-link",
    redirect: (to) =>
      to.query.key
        ? { name: "business-app", params: { businessKey: to.query.key }, query: {} }
        : { name: "download", query: {} },
  },
  {
    // Vuetify only loads with this chunk.
    path: "/payments",
    name: "payments",
    component: () => import("../views/PaymentsView.vue"),
    meta: { title: "כרטיס אשראי — אפלאטס" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/NotFoundView.vue"),
    meta: { title: "הדף לא נמצא — אפלאטס" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    }
    return { top: 0 };
  },
});

// index.html carries the studio page's description; routes may swap it.
const descriptionTag = document.querySelector('meta[name="description"]');
const defaultDescription = descriptionTag?.getAttribute("content") ?? "";

router.afterEach((to) => {
  if (to.meta?.title) {
    document.title = to.meta.title;
  }
  descriptionTag?.setAttribute(
    "content",
    to.meta?.description ?? defaultDescription
  );
});

export default router;
